$(document).ready(function() {

    var aboutWebswiper = new Swiper(".js-aboutWeb-swiper", {
        slidesPerView: "auto",
        centeredSlides: true,
        // effect: 'slide',
        autoHeight: true,
        slideToClickedSlide: true,
        // centeredSlides: true,
        onSlideChangeEnd: function(e) {
            aboutWebswiper.update(true);
        }

    });

    var aboutContentWebswiper = new Swiper(".js-aboutWeb-content-swiper", {
        slidesPerView: 1,


    });



    aboutWebswiper.controller.control = aboutContentWebswiper;
    aboutContentWebswiper.controller.control = aboutWebswiper;

})